<template>
  <div class="view-point-wrap" v-if="articleList.length>0">
    <div class="title sepBottom S8 T1">相关观点</div>
    <div
      class="content sepBottom"
      v-for="(item, index) in articleList"
      :key="index"
      @click="goto(item.uri)"
    >
      <div class="left">
        <div class="top S8 T1">{{item.title}}</div>
        <div
          class="time S4 T3"
        >{{ dayjs(item.publishTime).format('YYYY-MM-DD') }}</div>
      </div>
      <div
        class="right"
        :style="{backgroundImage:`url('${item.coverImageUrl}')`}"
      ></div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs'
import util from '@/util/util'

export default {
  components: {},
  props: ['articleList'],
  computed: {},
  methods: {
    dayjs,
    // emitId(id) {
    //   this.$emit('emitId', id)
    // },
    goto(uri) {
      let urL = 'ycstock://web?url=' + escape(uri)
      console.log(urL)
      util.go(urL)
    },
  },
}
</script>
<style lang="scss" scoped>
.view-point-wrap {
  .content {
    margin: 0 30px;
    padding: 30px 0;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    .left {
      display: flex;
      flex-direction: column;
      height: 150px;
      justify-content: space-between;
    }
    .right {
      width: 200px;
      height: 150px;
      border-radius: 5px;
      flex: none;
      margin-left: 58px;
      background-repeat: no-repeat;
      background-size: cover;
    }
  }
  .title {
    font-weight: 700;
    padding: 38px 0 38px 30px;
  }
}
</style>
